 import {Component, Input, OnInit} from '@angular/core';
import {QuestionModel} from '../../../../../models/questions/question.model';
import {SingleSubtractionNeededAmountModel} from '../../../../../models/questions/subModels/singleSubtractionNeededAmount.model';
import {min} from 'rxjs/operators';
 import {Enums} from '../../../../../models/extensions/enums';

@Component({
  selector: 'app-evo-single-subtraction-needed-amount',
  templateUrl: './evo-single-subtraction-needed-amount.component.html',
  styleUrls: ['./evo-single-subtraction-needed-amount.component.css']
})
export class EvoSingleSubtractionNeededAmountComponent implements OnInit {

  Enums = Enums;
  // QuestionModel = QuestionModel;
  @Input() question: QuestionModel = new SingleSubtractionNeededAmountModel();

  constructor() { }

  ngOnInit() {
  }

  castedQuestion(): SingleSubtractionNeededAmountModel {

    return <SingleSubtractionNeededAmountModel>this.question;
  }

  getOutcomeString(): string {

    let minOutcome = this.castedQuestion().model.total.maxValue() - this.castedQuestion().model.firstRange.minValue();
    let maxOutcome = this.castedQuestion().model.firstRange.maxValue() - this.castedQuestion().model.total.minValue();


    if (this.castedQuestion().model.minOutcome !== null) {

      if (minOutcome <= this.castedQuestion().model.minOutcome &&
        maxOutcome >= this.castedQuestion().model.minOutcome) {
        minOutcome = this.castedQuestion().model.minOutcome;
      }
    }

    if (this.castedQuestion().model.maxOutcome !== null) {

      if (minOutcome <= this.castedQuestion().model.maxOutcome &&
        maxOutcome >= this.castedQuestion().model.maxOutcome) {
        maxOutcome = this.castedQuestion().model.maxOutcome;
      }

    }


    let outcome = '[' + minOutcome.toString(10) + ', ';
    outcome += maxOutcome + ']';

    return outcome;
  }

  showQuestion(): boolean {

    if (this.question) {
      if (this.question.subCategory === Enums.QuestionSubcategories.singleSubtractionNeededAmount) {
        return true;
      }
    }

    return false;
  }

}
